import React, { Component } from 'react';
import SearchBar from '../SearchBar/SearchBar';
import Footer from '../ui/Footer';
import HomeImage from '../assets/homeimage/homeimage';
import './home.css';
import youtubeapi from '../../apis/youtubeapi';
import CategorieContainer from '../categoriecontainer/CategorieContainer';
import CourseContainer from '../coursecontainer/CourseContainer';
import Navbar from '../navbar/NavBar';
import YoutubeList from '../youtubecourses/YoutubeList';
import CoursePlayer from '../youtubecourses/CoursePlayer';

const KEY = "AIzaSyByxfgdmu31ObaRu2YEOzfVnTu5oFHvSoc";

class successfullLoged extends Component{
    state = {categorie: "Development",
             logged: true, 
             courses: [],
             selectedCourse: null};


    componentDidMount() {
      this.onTermSubmit('Java');
    }


    onTermSubmit = async term => {
        const response = await youtubeapi.get('/search',{
            params: {
                q: term,
                part: 'snippet', 
                type: 'video',
                maxResults: 5,
                key: KEY
            }
        });
        this.setState({
          courses: response.data.items,
          selectedCourse: response.data.items[0]
        });
    };

    onCourseSelect = (course) =>{
      this.setState({ selectedCourse: course});
    };

    categorieSelectedtHandler = async ( type ) => {
      await this.setState({categorie: type});
  }


  render(){
    return(
      <div>
      <Navbar logged= {this.state.logged} username={this.props.history.location.state.username}></Navbar>
      <div className="container">
        <div className="home-page">
          <div className="main-section">
            <HomeImage />
            <div className="home-desc">
              <h1>Learn on your own pace</h1>
              <p>Study Anytime, The Topic You Choose</p>
            <SearchBar onFormSubmit={this.onTermSubmit}></SearchBar>
            </div>
          </div>
        </div>

        <div className="ui grid">
          <div className="ui row">
            <div className="five wide column">
                <YoutubeList onCourseSelect={this.onCourseSelect} courses={this.state.courses} />   
            </div>

            <div className="ten wide column">
                <CoursePlayer coursedetails={this.state.selectedCourse} />
            </div>
          </div>
        </div>

        <div>
          <CategorieContainer categorieSelected={this.categorieSelectedtHandler}></CategorieContainer>
          <CourseContainer courseCategorie={this.state.categorie}></CourseContainer>
          <Footer/>
        </div>
      </div>
      </div>
  )

  }
}


export default successfullLoged;